export const INTENT_SCORE_MIN: number = 60;
export const INTENT_SCORE_MAX: number = 100;


